import React from 'react';

import Spinner from '../Spinner/index.jsx';
import ReactionItem from './ReactionItem.jsx';
import articleModalService from '../../Services/ArticleModal/index.jsx';

class ArticleReaction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      busy: true,
      article: this.props.article
    };

    this.populateReactions = this.populateReactions.bind(this)
  }

  populateReactions(e) {
    this.setState({
      article: {
        ...this.state.article,
        reactions: e.value
      }
    });
  }

  componentDidMount() {
    if (this.props.article?.reactions) {
      this.setState({
        busy: false,
        article: this.props.article
      })
    }
  }

  render() {
    return (
      <div className="cs-article-reactions">
        {this.state.busy?(
          <Spinner/>
        ):(
          Object.keys(this.props.article.reactions.value).map((key, index)=>(
            <ReactionItem key={key} type={key} onReactionUpdate={this.populateReactions} article={this.state.article} />
          ))
        )}
      </div>
    );
  }
}

export default ArticleReaction;

